var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
var jwtDecode = require('jwt-decode');
import AppConst from './AppConst.js'
import { CognitoUserSession } from 'amazon-cognito-identity-js';

var poolData = AppConst.poolData;
var userData;
var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
var cognitoUser = userPool.getCurrentUser();
var appTitle = "Voice Tracker";
var today = AppConst.today;


export default {
    AmazonCognitoIdentity: AmazonCognitoIdentity,
    poolData: poolData,
    userPool: userPool,
    cognitoUser: cognitoUser,
    appTitle: appTitle,

    forgotLogin(that, vusername, callback) {
        // this works, is a little clunky
        if (vusername == "") {
            var tmess = "Please enter a username";
            callback(tmess, null);
            return false;
        }

        userData = {
            Username: vusername,
            Pool: userPool
        };

        cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.forgotPassword({
            onSuccess: function(err, data) {
                callback(err.message, data);
            },
            onFailure: function(err, data) {
                callback(err.message, data);
            }
        });
    },
    confirmForgotPassword(that, verificationCode, newPassword, callback) {

        cognitoUser.confirmPassword(verificationCode, newPassword, {
            onSuccess: function() {
                callback(null, true);
            },
            onFailure: function(err) {
                callback(err.message, null);
            }
        });

    },
    registerUser(regname, regemail, password, callback) {

        if (regname === '' || regemail === '' || password === '') {
            var err = 'Please enter a username, email and password to register for an account.';
            callback(err, '');
            throw err;
        }

        var attributeList = [];

        var dataEmail = {
            Name: 'email',
            Value: regemail
        };

        var attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(dataEmail);

        attributeList.push(attributeEmail);

        userPool.signUp(regname, password, attributeList, null, function(err, result) {
            if (err) {
                callback(err, result);
            } else {
                cognitoUser = result.user;
                localStorage.subID = result.userSub;
                //sub id for cognito user is in result at result.userSub
                //use this value to create user data for appsync/dynamo  
                //redirect to home/login page
                callback(null, AppConst.registerUserConfirmationMessage);
            }
        });

    },

    logUserIn(vusername, vpassword, callback) {

        if (vusername === '' || vpassword === '') {
            var tmess = "Please enter a username and password.  To register for an account, use the 'Create Account' button.";
            console.log('No username or password.');
            callback(tmess, null);
            return;
        }

        var authenticationData = {
            Username: vusername,
            Password: vpassword,
        };
        var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);

        var userData = {
            Username: vusername,
            Pool: userPool
        };
        cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function(result) {
                //Use the idToken for Logins Map when Federating User Pools with identity pools or when passing through an Authorization Header to an API Gateway Authorizer
                var authResult = result;
                cognitoUser.getSession(function(err, session) {
                    if (err) {
                        callback(err.message, null);
                    }


                    var jwtDecode = require('jwt-decode');
                    var decoded = jwtDecode(authResult.idToken.jwtToken);
                    localStorage.username = vusername;
                    localStorage.email = decoded.email;
                    localStorage.sessionValid = session.isValid();
                    localStorage.currentDate = today;
                    localStorage.subID = decoded.sub;
                    localStorage.userSub = decoded.sub;
                    localStorage.userGroup = decoded['cognito:groups'];

                    cognitoUser.setDeviceStatusRemembered({
                        onSuccess: function(result) {
                            callback(null, result);
                        },

                        onFailure: function(err) {
                            console.log(err);
                            callback(null, result);
                        }
                    });


                });


            },
            onFailure: function(err) {
                if (err.name == 'UserNotConfirmedException') {
                    var errMessUser = err.message + ' Please confirm your account. Check your email for the account creation confirmation message.'
                    callback(errMessUser, null);

                } else {
                    var errMess = err.message + '  Please try again.';
                    callback(errMess, null);
                }
            },
        });



    },
    logUserOut() {
        localStorage.refreshToken = '';
        cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {
            cognitoUser.signOut();
            window.location.pathname = '/';
        }
    },
    getRefreshToken(that, callback) {

        if (localStorage.refreshToken && localStorage.refreshToken != '') {

            var cogSessionVal = '';
            const RefreshToken = new AmazonCognitoIdentity.CognitoRefreshToken({ RefreshToken: localStorage.refreshToken });
            const userData = {
                Username: localStorage.username,
                Pool: userPool
            };

            var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);


            const AccessToken = new AmazonCognitoIdentity.CognitoAccessToken({ AccessToken: localStorage.accessToken });
            const IdToken = new AmazonCognitoIdentity.CognitoIdToken({ IdToken: localStorage.idToken });
            const sessionData = {
                IdToken: IdToken,
                AccessToken: AccessToken,
                RefreshToken: RefreshToken
            };
            const userSession = new CognitoUserSession(sessionData);
            cognitoUser.setSignInUserSession(userSession);


            cognitoUser.refreshSession(RefreshToken, function(err, session) {
                if (err) {
                    callback(false);
                }

                try {
                    cogSessionVal = session.isValid();
                } catch {
                    callback("not a valid session", cogSessionVal = false);
                }
                if (cogSessionVal === true) {
                    // Update attributes or whatever else you want to do
                    console.log(session);

                    if (cogSessionVal === true) {
                        localStorage.username = cognitoUser.username;
                    }
                    var decoded = jwtDecode(session.idToken.jwtToken);
                    localStorage.username = cognitoUser.username
                    localStorage.email = decoded.email;
                    localStorage.sessionValid = session.isValid();
                    localStorage.currentDate = today;
                    localStorage.subID = decoded.sub;
                    localStorage.userSub = decoded.sub;
                    localStorage.refreshToken = session.getRefreshToken().token;
                    localStorage.idToken = session.getIdToken().token;
                    localStorage.accessToken = session.getAccessToken().jwtToken;
                    that.getSession(that, function() {
                        callback(cogSessionVal);
                    });

                } else {
                    // TODO: What to do if session is invalid?
                }
            });
        } else {
            callback(false);
        }
    },
    getSession(that, callback) {

        var cogSessionVal = '';
        cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {


            cognitoUser.getSession(function(err, session) {
                if (err) {
                    console.log(err);
                    callback(cogSessionVal = session.isValid());
                }
                cogSessionVal = session.isValid();


                localStorage.refreshToken = session.getRefreshToken().token;
                localStorage.idToken = session.getIdToken().token;
                localStorage.accessToken = session.getAccessToken().jwtToken;
                if (cogSessionVal === true) {
                    localStorage.username = cognitoUser.username;
                }
                callback(cogSessionVal);
            });
        } else {
            callback(false);
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/LoginService.js